import { UserScreenshareSource } from 'features/layout/features/order/types';
import { FeedId } from 'features/streaming/types';

export const getScreenshareFeedIds = (streams: UserScreenshareSource[]): string[] =>
  streams.map((stream) => stream.feedId).filter((feedId): feedId is FeedId => Boolean(feedId));
